import React from 'react';

import PublicLayout from 'components/layouts/Public';
import LogInForm from 'components/authForms/LogInForm';

import FormSection from 'ui/FormSection';

import { t } from 'i18n/index';
import AuthSwitchLink from './AuthSwitchLink';
import FooterLabels from './FooterLabels';

const Login = () => {
  return (
    <PublicLayout isLogin={true} >
        <FormSection slim>
          <div className="form-title hidden">{t('account:login:pageTitle')}</div>
          <LogInForm />
          <AuthSwitchLink to="/signup" />
        </FormSection>

        <FooterLabels />
    </PublicLayout>
  );
};

export default Login;
